import React from "react";
import TextInput from "../TextInput";
import classNames from "classnames";
import Button from "../Button";

export default class SearchField extends React.Component {
    render() {
        return (
            <div className="search-field">
                <div className={classNames({"input-group": (this.props.search || '').length})}>
                    <TextInput
                        label={false}
                        value={this.props.search}
                        placeholder="Keresés..."
                        saveChanges={(field, value) => this.props.onSearch(value.trim())}
                    />
                    {!!(this.props.search || '').length && <span className="input-group-btn">
                        <Button icon={{lib: "fa", name: "times"}} color="default" onClick={() => this.props.onSearch(null)} />
                    </span>}
                </div>
            </div>
        );
    }
}